module.exports = __webpack_public_path__ + "img/mobile-en.33b92e53.jpg";